<template>
    <div>
        <Menu mode="horizontal" :theme="'light'" class="tabs" :active-name="current" @on-select="menuChange">
            <MenuItem name="MyTeam">
                我的团队
            </MenuItem>
            <MenuItem name="AllTeam">
                全部团队
            </MenuItem>
            <MenuItem name="TeamRequest">
                团队请求
            </MenuItem>
            <MenuItem name="SubmitRecord">
                提交记录
            </MenuItem>
        </Menu>
        <div style="padding-top:10px;">
            <components :is="current"></components>
        </div>
    </div>
</template>
<script>
    import MyTeam from "./components/my_team"
    import AllTeam from "./components/all_team"
    import TeamRequest from "./components/team_request"
    import SubmitRecord from "./components/submit_record"
    export default {
        components:{
            MyTeam,
            AllTeam,
            TeamRequest,
            SubmitRecord
        },
        data(){
            return {
                current:'MyTeam'
            }
        },
        methods:{
            menuChange(name){
                this.current = name;
            }
        }
    }
</script>